import * as ng from 'angular';

export class TimeoutController implements ng.IComponentController {
   static $inject = ['$window'];

   constructor(
      private $window:ng.IWindowService,
   ) {}

   reload() {
      this.$window.location.href = "/";
   }
}

ng.module('selfReg').component('timeout', {
   templateUrl: require('./timeout.html'),
   controller: TimeoutController
});
